import { AxiosInstance } from "axios"

import { getPropertyNotesApi } from "commonModule/services/booking/propertyNotesApi"
import { createFavoriteListByPropertyIdApi } from "commonModule/services/favorite/createFavoriteListByPropertyId"
import { getSearchPropertyByIdAPI } from "commonModule/services/homepage/propertyLookupAPI"
import {
  createUpdatePriceDropAlertApi,
  getPriceDropAlertApi,
  getPriceDropAlertNotificationApi,
  priceDropAlertReadNotificationApi,
  getPropertyIdBasedPriceDropAlertApi,
} from "commonModule/services/priceDropAlert"
import { setUpAccountPasswordAPI } from "commonModule/services/thankyou-page/setUpAccountPasswordApi"

import { createAgencyUserApi } from "./agent/createAgencyUser"
import { createStripeAccountLinkApi } from "./agent/createStripeAccountLink"
import { deleteAgencyUserApi } from "./agent/deleteAgencyUser"
import { generateShareLinkApi } from "./agent/generateShareLink"
import { getAgencyUsersApi } from "./agent/getAgencyUsers"
import { getAgentBookingsApi } from "./agent/getAgentBookings"
import { getAgentCommissionsApi } from "./agent/getAgentCommissions"
import { getAgentCountryListApi } from "./agent/getCountryList"
import { getPayoutConfigApi } from "./agent/getPayoutConfig"
import { getStripeAccountDetailsApi } from "./agent/getStripeAccountDetails"
import { getStripeAccountOptionsApi } from "./agent/getStripeAccountOptions"
import { getSuperAgent } from "./agent/getSuperAgent"
import { resendAgencyInviteApi } from "./agent/resendAgencyInvite"
import { stripeOnboardApi } from "./agent/stripeOnboard"
import {
  updateAgencyUserRoleApi,
  UpdateAgencyUserRoleApiRequest,
} from "./agent/updateAgencyUserRole"
import { updatePayoutConfigApi } from "./agent/updatePayoutConfig"
import { sendLinkOnNumberApi, getAllFiltersApi } from "./app"
import { checkMobileEmailExistAPI } from "./auth/checkExistingUser"
import { verifySigninOtpAPI } from "./auth/otp"
import { verifyPasswordAPI } from "./auth/password"
import { requestEmailOtpAPI } from "./auth/resendEmailOtp"
import { resendMobileOtpAPI } from "./auth/resendMobileOtp"
import { resendOtpAPI } from "./auth/resendOtp"
import {
  resetPasswordApi,
  setNewPasswordApi,
  verifyResetPasswordLinkApi,
} from "./auth/resetPassword"
import {
  marketingInfoOptInOut,
  saveUserApi,
  signUpGuestUserWithEmailApi,
  signUpUserWithEmailApi,
} from "./auth/saveUser"
import { sendOtpAPI } from "./auth/sendOtp"
import { signInWithPasswordAPI } from "./auth/signInWithPassword"
import { softLoginAPI } from "./auth/softLogin"
import { validateAppleTokenAPI } from "./auth/validateAppleToken"
import { validateGoogleTokenAPI } from "./auth/validateGoogleToken"
import { verifyEmailOtpAPI } from "./auth/verifyEmailOtpApi"
import { verifyMobileOtpAPI } from "./auth/verifyMobileOtpAPI"
import { affirmVisibilityApi } from "./booking/affirm"
import { attemptBookingApi } from "./booking/booking"
import { bookingModificationRequestApi } from "./booking/bookingModificationRequest"
import { getCardDetailsByIdApi, getPaymentCardsApi } from "./booking/cards"
import { confirmStagedBookingApi } from "./booking/confirmStagedBooking"
import { getListOfPromocodesAPI } from "./booking/getListOfPromocodes"
import { createSetupIntentAPI } from "./booking/getSetupIntent"
import { logStripeErrorApi } from "./booking/log-stripe-error"
import {
  getPrecisionPricingApi,
  getPrecisionPricingStatusApi,
} from "./booking/precisionPricing"
import { getPrequoteApi } from "./booking/prequote"
import { confirmBookingApi } from "./booking/proceed"
import { processStagedBookingApi } from "./booking/processStagedBooking"
import {
  cancelPromoCodeApi,
  promoCodeApi,
  refundableApi,
  saveCampaignApi,
} from "./booking/promoCode"
import { promoCodeDetailsApi } from "./booking/promoCodeDetail"
import { getReceiptURLAPI } from "./booking/receiptAPI"
import {
  getTravellerAddressApi,
  bookingGuestInfoApi,
} from "./booking/traveller"
import { createVerificationSessionApi } from "./booking/verificationSession"
import {
  setInviteStatusUpdateApi,
  getBookingListApi,
  getBookingDataFromBookingNoApi,
  getCountriesAndStatesList,
} from "./bookings"
import { getCoverageValueApi } from "./calendar"
import { getCancelBookingApi } from "./cancel-booking/getCancelBookingApi"
import { getCancellationSummaryAPI } from "./cancel-booking/getCancellationSummary"
import { getListOfCancellationReasonsAPI } from "./cancel-booking/getListOfCancellationReasons"
import { getDeviceIdApi } from "./deviceId"
import { createFavoriteListApi } from "./favorite/createFavouriteList"
import { getAllFavoriteListOptimizedApi } from "./favorite/getAllFavoriteList"
import { getAllFavoritePropertyIdsApi } from "./favorite/getAllFavoritePropertyIdsFromAllLists"
import {
  getSpecificFavoriteListWithIdApi,
  getSpecificFavoriteListWithIdOptimizedApi,
} from "./favorite/getSpecificFavoriteListWithId"
import { getWatchListPropertiesApi } from "./favorite/getWatchListProperties"
import { removeExpiredTagApi } from "./favorite/removeExpiredTag"
import { deleteFavouriteListApi } from "./favorite/removeFavList"
import { removePropertyFromFavoriteListApi } from "./favorite/removePropertyFromFavList"
import { renameFavoriteListApi } from "./favorite/renameFavoriteList"
import { searchFavoriteListsOptimizedApi } from "./favorite/search"
import { searchInFavoriteListOptimizedApi } from "./favorite/searchInFavList"
import { updateSharedFavoriteListApi } from "./favorite/sharedFavoriteList"
import { updateFavoriteListApi } from "./favorite/updateFavoriteList"
import { saveGAIdApi } from "./gaId"
import { getCommonFAQAPI } from "./homepage/commonFAQsAPI"
import { getBlogPropertiesDataAPI } from "./homepage/getBlogPropertiesDataAPI"
import { getHeroBannerDataAPI } from "./homepage/getHeroBannerDataAPI"
import { getPropertiesFromConfigAPI } from "./homepage/getPropertiesFromConfigAPI"
import { getPropertiesFromRecommendedAPI } from "./homepage/getPropertiesFromRecommendedAPI"
import { getPropertyConfigsAPI } from "./homepage/getPropertyConfigsAPI"
import { getTestimonialsAPI } from "./homepage/getTestimonialsAPI"
import { getTrendingLocationsAPI } from "./homepage/getTrendingLocationsAPI"
import { subscribeNewsletterAPI } from "./homepage/subscribeNewsletterAPI"
import { getPropertyConfigsV2API } from "./homepageV2/getPropertyConfigsV2API"
import { getMultiUnitsPropertyDetailsApi } from "./multi-units/getMultiUnitsPropertyDetailsApi"
import {
  verifyEmailAddressApi,
  sendVerifyEmailApi,
  getFaqsLocaleBasedApi,
} from "./profile"
import { getPropertyAdditionalInfoApi } from "./propertyAddtionalInfo"
import { getPropertyDetailsApi } from "./propertyDetail"
import { getPropertyCalendarApi } from "./propertyDetailNoCalendar"
import { getPropertyImages } from "./propertyImages"
import {
  getNearbyDestinationApi,
  getNearbyPropertiesAPI,
} from "./propertyNearby"
import { getPropertyReviewsApi } from "./propertyReviews"
import {
  getRecentlySearchesApi,
  saveRecentlySearchesApi,
} from "./recently-search/recently-search"
import { getPropertiesFromRegionalAPI } from "./regional-landing/getPropertiesFromRegionalAPI"
import { getPropertiesFromStaticRegionalAPI } from "./regional-landing/getPropertiesFromStaticRegionalAPI"
import { getRegionalContentAPI } from "./regional-landing/getRegionalContentAPI"
import { getRegionalReviewsAPI } from "./regional-landing/getRegionalReviewsAPI"
import { getRegionalStaticPageAPI } from "./regional-landing/getRegionalStaticPageAPI"
import { getReviewsContentAPI } from "./reviews/getReviewsContentAPI"
import { getReviewsListAPI } from "./reviews/getReviewsListAPI"
import { saveRecentViewApi, getRecentViewPropertyApi } from "./saveSearch"
import {
  getPropertiesGetApi,
  getPropertiesCountGETApi,
  SearchDotPropertyCardApi,
  getMapCoordinatesApi,
  getPriceBarChartApi,
} from "./search"
import { registerIndexedPageInfoApi } from "./seo/logVacationRentalPageIndexed"
import { getSitemapListApi } from "./sitemap"
import { verifySubscribeEmailApi, decryptEmailApi } from "./subscribe"
import { getSurveyDetailsApi, saveSurveyDetailApi } from "./survey"
import { getTripDetailsApi } from "./tripdetails"
import {
  getUserDetailsApi,
  updateUserDetailsApi,
  deleteUserDetailsApi,
  getInvitationsApi,
  blockUserApi,
  subscribeApi,
} from "./user"

export class CommonClient {
  private axiosInstance: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance
  }

  ////////////////////////////// FAQs ////////////////////////
  getFaqsLocaleBased(request: Parameters<typeof getFaqsLocaleBasedApi>[0]) {
    return getFaqsLocaleBasedApi(request, this.axiosInstance)
  }

  ////////////////////////////// Sitemap ////////////////////////
  getSiteMapList(request: Parameters<typeof getSitemapListApi>[0]) {
    return getSitemapListApi(request, this.axiosInstance)
  }
  ///////////////////////////////////////////////////

  sendLinkOnNumber(request: Parameters<typeof sendLinkOnNumberApi>[0]) {
    return sendLinkOnNumberApi(request, this.axiosInstance)
  }
  //////////////////////// Survey Api //////////////////

  getSurveyDetails(request: Parameters<typeof getSurveyDetailsApi>[0]) {
    return getSurveyDetailsApi(request, this.axiosInstance)
  }

  saveSurveyDetails(request: Parameters<typeof saveSurveyDetailApi>[0]) {
    return saveSurveyDetailApi(request, this.axiosInstance)
  }

  ////////////////////////// Split Payment Invite ////////////////////

  inviteStatusUpdate(request: Parameters<typeof setInviteStatusUpdateApi>[0]) {
    return setInviteStatusUpdateApi(request, this.axiosInstance)
  }

  searchDotPropertyCard(
    request: Parameters<typeof SearchDotPropertyCardApi>[0],
  ) {
    return SearchDotPropertyCardApi(request, this.axiosInstance)
  }

  getPropertyDetails(request: Parameters<typeof getPropertyDetailsApi>[0]) {
    return getPropertyDetailsApi(request, this.axiosInstance)
  }

  getPropertyImages(request: Parameters<typeof getPropertyImages>[0]) {
    return getPropertyImages(request, this.axiosInstance)
  }

  getPropertyReviewsApi(request: Parameters<typeof getPropertyReviewsApi>[0]) {
    return getPropertyReviewsApi(request, this.axiosInstance)
  }

  getPropertyAdditionalInfoApi(
    request: Parameters<typeof getPropertyAdditionalInfoApi>[0],
  ) {
    return getPropertyAdditionalInfoApi(request, this.axiosInstance)
  }

  getPropertyCalendar(request: Parameters<typeof getPropertyCalendarApi>[0]) {
    return getPropertyCalendarApi(request, this.axiosInstance)
  }

  getMapCoordinates(request: Parameters<typeof getMapCoordinatesApi>[0]) {
    return getMapCoordinatesApi(request, this.axiosInstance)
  }

  //////////////////////////////search page price drop alerts API//////////////////////

  createUpdatePriceDropAlert(
    request: Parameters<typeof createUpdatePriceDropAlertApi>[0],
  ) {
    return createUpdatePriceDropAlertApi(request, this.axiosInstance)
  }

  getPriceDropAlertApi() {
    return getPriceDropAlertApi(this.axiosInstance)
  }

  getPropertyIdBasedPriceDropAlert(
    request: Parameters<typeof getPropertyIdBasedPriceDropAlertApi>[0],
  ) {
    return getPropertyIdBasedPriceDropAlertApi(request, this.axiosInstance)
  }

  priceDropAlertNotificationApi() {
    return getPriceDropAlertNotificationApi(this.axiosInstance)
  }

  priceDropAlertReadNotification(
    request: Parameters<typeof priceDropAlertReadNotificationApi>[0],
  ) {
    return priceDropAlertReadNotificationApi(request, this.axiosInstance)
  }

  //////////////////////////////Multi Unit Detail API//////////////////////

  getMultiUnitsPropertyDetails(
    request: Parameters<typeof getMultiUnitsPropertyDetailsApi>[0],
  ) {
    return getMultiUnitsPropertyDetailsApi(request, this.axiosInstance)
  }

  //////////////////////////////Booking List API//////////////////////

  getBookingTrips() {
    return getBookingListApi(this.axiosInstance)
  }

  getbookingDetails(
    request: Parameters<typeof getBookingDataFromBookingNoApi>[0],
  ) {
    return getBookingDataFromBookingNoApi(request, this.axiosInstance)
  }

  //////////////////////////////////////////////////////////////////////

  getTripDetailsApi(email: Parameters<typeof getTripDetailsApi>[0]) {
    return getTripDetailsApi(email, this.axiosInstance)
  }

  getPropertiesGet(request: Parameters<typeof getPropertiesGetApi>[0]) {
    return getPropertiesGetApi(request, this.axiosInstance)
  }

  getPropertiesCountGET(
    request: Parameters<typeof getPropertiesCountGETApi>[0],
  ) {
    return getPropertiesCountGETApi(request, this.axiosInstance)
  }

  getPriceBarChart(request: Parameters<typeof getPriceBarChartApi>[0]) {
    return getPriceBarChartApi(request, this.axiosInstance)
  }

  ////////////////////////////////////////////////////

  // Promo code
  cancelPromoCode(request: Parameters<typeof cancelPromoCodeApi>[0]) {
    return cancelPromoCodeApi(request, this.axiosInstance)
  }

  getPromoCode(request: Parameters<typeof promoCodeApi>[0]) {
    return promoCodeApi(request, this.axiosInstance)
  }

  promoCodeDetails(request: Parameters<typeof promoCodeDetailsApi>[0]) {
    return promoCodeDetailsApi(request, this.axiosInstance)
  }

  saveCampaign(request: Parameters<typeof saveCampaignApi>[0]) {
    return saveCampaignApi(request, this.axiosInstance)
  }

  //////////////////////////////////////////////////

  getFilterParameters() {
    return getAllFiltersApi(this.axiosInstance)
  }

  getCoverageValue() {
    return getCoverageValueApi(this.axiosInstance)
  }

  // countries & states list
  getCountries() {
    return getCountriesAndStatesList(this.axiosInstance)
  }

  ///////////////////////////////////////////////////////
  registerIndexedPageInfo(
    req: Parameters<typeof registerIndexedPageInfoApi>[0],
  ) {
    return registerIndexedPageInfoApi(req, this.axiosInstance)
  }

  getRecentlySearches() {
    return getRecentlySearchesApi(this.axiosInstance)
  }

  saveRecentlySearches(request: Parameters<typeof saveRecentlySearchesApi>[0]) {
    return saveRecentlySearchesApi(request, this.axiosInstance)
  }

  // Thankyou page setup your account password APIs
  setUpAccountPassword(request: Parameters<typeof setUpAccountPasswordAPI>[0]) {
    return setUpAccountPasswordAPI(request, this.axiosInstance)
  }
}

export class DeviceIdClient {
  private axiosInstance: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance
  }

  getDeviceId() {
    return getDeviceIdApi(this.axiosInstance)
  }
}

export class UserClient {
  private axiosInstance: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance
  }

  // profile related
  getUser() {
    return getUserDetailsApi(this.axiosInstance)
  }

  updateUserDetails(request: Parameters<typeof updateUserDetailsApi>[0]) {
    return updateUserDetailsApi(request, this.axiosInstance)
  }

  saveUser(request: Parameters<typeof saveUserApi>[0]) {
    return saveUserApi(request, this.axiosInstance)
  }

  signUpUserWithEmail(request: Parameters<typeof signUpUserWithEmailApi>[0]) {
    return signUpUserWithEmailApi(request, this.axiosInstance)
  }

  signUpGuestUserWithEmail(
    request: Parameters<typeof signUpUserWithEmailApi>[0],
  ) {
    return signUpGuestUserWithEmailApi(request, this.axiosInstance)
  }

  marketingInfoOptInOut(request: Parameters<typeof marketingInfoOptInOut>[0]) {
    return marketingInfoOptInOut(request, this.axiosInstance)
  }

  deleteUser() {
    return deleteUserDetailsApi(this.axiosInstance)
  }

  getUserCards(request: Parameters<typeof getPaymentCardsApi>[0]) {
    return getPaymentCardsApi(request, this.axiosInstance)
  }

  getCardDetailsById(request: Parameters<typeof getCardDetailsByIdApi>[0]) {
    return getCardDetailsByIdApi(request, this.axiosInstance)
  }

  loadInvites(request: Parameters<typeof getInvitationsApi>[0]) {
    return getInvitationsApi(request, this.axiosInstance)
  }

  blockUser() {
    return blockUserApi(this.axiosInstance)
  }
}

export class AuthClient {
  private axiosInstance: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance
  }

  sendOtp(request: Parameters<typeof sendOtpAPI>[0]) {
    return sendOtpAPI(request, this.axiosInstance)
  }

  signInWithPassword(request: Parameters<typeof signInWithPasswordAPI>[0]) {
    return signInWithPasswordAPI(request, this.axiosInstance)
  }

  resendOtp(request: Parameters<typeof resendOtpAPI>[0]) {
    return resendOtpAPI(request, this.axiosInstance)
  }

  resendMobileOtpAPI() {
    return resendMobileOtpAPI(this.axiosInstance)
  }

  requestEmailOtpAPI() {
    return requestEmailOtpAPI(this.axiosInstance)
  }

  verifyPassword(request: Parameters<typeof verifyPasswordAPI>[0]) {
    return verifyPasswordAPI(request, this.axiosInstance)
  }

  verifyOtp(request: Parameters<typeof verifySigninOtpAPI>[0]) {
    return verifySigninOtpAPI(request, this.axiosInstance)
  }

  verifyMobileOtpAPI(request: Parameters<typeof verifyMobileOtpAPI>[0]) {
    return verifyMobileOtpAPI(request, this.axiosInstance)
  }

  verifyEmailOtpAPI(request: Parameters<typeof verifyEmailOtpAPI>[0]) {
    return verifyEmailOtpAPI(request, this.axiosInstance)
  }

  checkMobileEmailExistAPI(
    request: Parameters<typeof checkMobileEmailExistAPI>[0],
  ) {
    return checkMobileEmailExistAPI(request, this.axiosInstance)
  }

  verifyEmailAddress(request: Parameters<typeof verifyEmailAddressApi>[0]) {
    return verifyEmailAddressApi(request, this.axiosInstance)
  }

  sendVerificationEmail() {
    return sendVerifyEmailApi(this.axiosInstance)
  }

  resetPassword(request: Parameters<typeof resetPasswordApi>[0]) {
    return resetPasswordApi(request, this.axiosInstance)
  }

  setNewPassword(request: Parameters<typeof setNewPasswordApi>[0]) {
    return setNewPasswordApi(request, this.axiosInstance)
  }

  verifyResetPasswordLink(
    request: Parameters<typeof verifyResetPasswordLinkApi>[0],
  ) {
    return verifyResetPasswordLinkApi(request, this.axiosInstance)
  }

  validateGoogleToken() {
    return validateGoogleTokenAPI(this.axiosInstance)
  }

  validateAppleToken() {
    return validateAppleTokenAPI(this.axiosInstance)
  }

  softLogin(request: Parameters<typeof softLoginAPI>[0]) {
    return softLoginAPI(request, this.axiosInstance)
  }
}

export class SaveSearchClient {
  private axiosInstance: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance
  }

  saveRecentView(request: Parameters<typeof saveRecentViewApi>[0]) {
    return saveRecentViewApi(request, this.axiosInstance)
  }

  getRecentViewProperty(
    request: Parameters<typeof getRecentViewPropertyApi>[0],
  ) {
    return getRecentViewPropertyApi(request, this.axiosInstance)
  }
}

export class SubscribeClient {
  private axiosInstance: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance
  }

  // email suscribe related methods

  // function for suscribe email
  subscribe(request: Parameters<typeof subscribeApi>[0]) {
    return subscribeApi(request, this.axiosInstance)
  }

  verifySubEmail(email: Parameters<typeof verifySubscribeEmailApi>[0]) {
    return verifySubscribeEmailApi(email, this.axiosInstance)
  }

  decryptEmail(email: Parameters<typeof decryptEmailApi>[0]) {
    return decryptEmailApi(email, this.axiosInstance)
  }

  getTripDetailsApi(email: Parameters<typeof getTripDetailsApi>[0]) {
    return getTripDetailsApi(email, this.axiosInstance)
  }
}

export class FavClient {
  private axiosInstance: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance
  }

  searchInFavoriteList(
    request: Parameters<typeof searchInFavoriteListOptimizedApi>[0],
  ) {
    return searchInFavoriteListOptimizedApi(request, this.axiosInstance)
  }

  searchFavoriteLists(
    request: Parameters<typeof searchFavoriteListsOptimizedApi>[0],
  ) {
    return searchFavoriteListsOptimizedApi(request, this.axiosInstance) // new api optimized version
  }

  // mobile only // will deprecate soon
  getSpecificFavoriteListWithIdOld(
    request: Parameters<typeof getSpecificFavoriteListWithIdApi>[0],
  ) {
    return getSpecificFavoriteListWithIdApi(request, this.axiosInstance)
  }

  getSpecificFavoriteListWithId(
    request: Parameters<typeof getSpecificFavoriteListWithIdOptimizedApi>[0],
  ) {
    return getSpecificFavoriteListWithIdOptimizedApi(
      request,
      this.axiosInstance,
    )
  }

  getWatchListProperties(
    request: Parameters<typeof getWatchListPropertiesApi>[0],
  ) {
    return getWatchListPropertiesApi(request, this.axiosInstance)
  }

  removeExpiredTag(request: Parameters<typeof removeExpiredTagApi>[0]) {
    return removeExpiredTagApi(request, this.axiosInstance)
  }

  getAllFavoriteList() {
    return getAllFavoriteListOptimizedApi(this.axiosInstance) // this is latest optimized version of api
  }

  getAllFavoritePropertyIds() {
    return getAllFavoritePropertyIdsApi(this.axiosInstance)
  }

  addToFavourites(request: Parameters<typeof createFavoriteListApi>[0]) {
    return createFavoriteListApi(request, this.axiosInstance)
  }

  createFavoriteListByPropertyId(
    request: Parameters<typeof createFavoriteListByPropertyIdApi>[0],
  ) {
    return createFavoriteListByPropertyIdApi(request, this.axiosInstance)
  }

  updateFavouriteList(request: Parameters<typeof updateFavoriteListApi>[0]) {
    return updateFavoriteListApi(request, this.axiosInstance)
  }

  updateSharedFavoriteList(
    request: Parameters<typeof updateSharedFavoriteListApi>[0],
  ) {
    return updateSharedFavoriteListApi(request, this.axiosInstance)
  }

  removeFromFavoriteList(
    request: Parameters<typeof removePropertyFromFavoriteListApi>[0],
  ) {
    return removePropertyFromFavoriteListApi(request, this.axiosInstance)
  }

  removeFavouriteList(request: Parameters<typeof deleteFavouriteListApi>[0]) {
    return deleteFavouriteListApi(request, this.axiosInstance)
  }

  renameFavouriteList(request: Parameters<typeof renameFavoriteListApi>[0]) {
    return renameFavoriteListApi(request, this.axiosInstance)
  }
}

export class BookingClient {
  private axiosInstance: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance
  }

  getPrequote(request: Parameters<typeof getPrequoteApi>[0]) {
    return getPrequoteApi(request, this.axiosInstance)
  }

  getTravellerAddress() {
    return getTravellerAddressApi(this.axiosInstance)
  }

  applyRefundable() {
    return refundableApi(this.axiosInstance)
  }

  affirmVisibility() {
    return affirmVisibilityApi(this.axiosInstance)
  }

  attemptBooking(request: Parameters<typeof attemptBookingApi>[0]) {
    return attemptBookingApi(request, this.axiosInstance)
  }

  confirmBooking(request: Parameters<typeof confirmBookingApi>[0]) {
    return confirmBookingApi(request, this.axiosInstance)
  }

  getReceiptURL(request: Parameters<typeof getReceiptURLAPI>[0]) {
    return getReceiptURLAPI(request, this.axiosInstance)
  }

  bookingGuestInfo(request: Parameters<typeof bookingGuestInfoApi>[0]) {
    return bookingGuestInfoApi(request, this.axiosInstance)
  }

  getListOfPromocodes() {
    return getListOfPromocodesAPI(this.axiosInstance)
  }

  createSetupIntentAPI() {
    return createSetupIntentAPI(this.axiosInstance)
  }

  processStagedBooking(request: Parameters<typeof processStagedBookingApi>[0]) {
    return processStagedBookingApi(request, this.axiosInstance)
  }

  confirmStagedBooking(request: Parameters<typeof confirmStagedBookingApi>[0]) {
    return confirmStagedBookingApi(request, this.axiosInstance)
  }

  createVerificationSession(
    request: Parameters<typeof createVerificationSessionApi>[0],
  ) {
    return createVerificationSessionApi(request, this.axiosInstance)
  }

  bookingModificationRequest(
    request: Parameters<typeof bookingModificationRequestApi>[0],
  ) {
    return bookingModificationRequestApi(request, this.axiosInstance)
  }

  getPrecisionPricing(request: Parameters<typeof getPrecisionPricingApi>[0]) {
    return getPrecisionPricingApi(request, this.axiosInstance)
  }

  getPrecisionPricingStatus(
    request: Parameters<typeof getPrecisionPricingStatusApi>[0],
  ) {
    return getPrecisionPricingStatusApi(request, this.axiosInstance)
  }

  logStripeError(request: Parameters<typeof logStripeErrorApi>[0]) {
    return logStripeErrorApi(request, this.axiosInstance)
  }

  getPropertyNotes(request: Parameters<typeof getPropertyNotesApi>[0]) {
    return getPropertyNotesApi(request, this.axiosInstance)
  }
}

export class CancelBookingClient {
  private axiosInstance: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance
  }

  getListOfCancellationReasons() {
    return getListOfCancellationReasonsAPI(this.axiosInstance)
  }

  getCancellationSummary(request: { bookingNo: string; reason: string }) {
    return getCancellationSummaryAPI(
      this.axiosInstance,
      request.bookingNo,
      request.reason,
    )
  }

  getCancelBooking(request: Parameters<typeof getCancelBookingApi>[0]) {
    return getCancelBookingApi(request, this.axiosInstance)
  }
}

export class NearbyDestinationClient {
  private axiosInstance: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance
  }

  getNearbyProperties(request: Parameters<typeof getNearbyPropertiesAPI>[0]) {
    return getNearbyPropertiesAPI(request, this.axiosInstance)
  }

  getNearbyDestinations(
    request: Parameters<typeof getNearbyDestinationApi>[0],
  ) {
    return getNearbyDestinationApi(request, this.axiosInstance)
  }
}

export class HomePageClient {
  private axiosInstance: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance
  }

  getCommonFAQ() {
    return getCommonFAQAPI(this.axiosInstance)
  }

  getTestimonials() {
    return getTestimonialsAPI(this.axiosInstance)
  }

  getTrendingLocations() {
    return getTrendingLocationsAPI(this.axiosInstance)
  }

  getPropertyConfigs() {
    return getPropertyConfigsAPI(this.axiosInstance)
  }

  getPropertyConfigsV2() {
    return getPropertyConfigsV2API(this.axiosInstance)
  }

  getPropertiesFromConfig(
    request: Parameters<typeof getPropertiesFromConfigAPI>[0],
  ) {
    return getPropertiesFromConfigAPI(request, this.axiosInstance)
  }

  getPropertiesFromRecommended(
    request: Parameters<typeof getPropertiesFromRecommendedAPI>[0],
  ) {
    return getPropertiesFromRecommendedAPI(request, this.axiosInstance)
  }

  subscribeNewsletter(request: Parameters<typeof subscribeNewsletterAPI>[0]) {
    return subscribeNewsletterAPI(request, this.axiosInstance)
  }

  getHeroBannerData(request: Parameters<typeof getHeroBannerDataAPI>[0]) {
    return getHeroBannerDataAPI(request, this.axiosInstance)
  }

  getBlogPropertiesData() {
    return getBlogPropertiesDataAPI(this.axiosInstance)
  }

  getSearchPropertyById(
    request: Parameters<typeof getSearchPropertyByIdAPI>[0],
  ) {
    return getSearchPropertyByIdAPI(request, this.axiosInstance)
  }
}

export class GAIdClient {
  private axiosInstance: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance
  }

  //API to save GA (google analytics) id in database
  saveGAIdApi(request: Parameters<typeof saveGAIdApi>[0]) {
    return saveGAIdApi(request, this.axiosInstance)
  }
}

export class RegionalLandingPageClient {
  private axiosInstance: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance
  }

  getRegionalContent(request: Parameters<typeof getRegionalContentAPI>[0]) {
    return getRegionalContentAPI(request, this.axiosInstance)
  }

  getRegionalReviews(request: Parameters<typeof getRegionalReviewsAPI>[0]) {
    return getRegionalReviewsAPI(request, this.axiosInstance)
  }

  getPropertiesFromRegional(
    request: Parameters<typeof getPropertiesFromRegionalAPI>[0],
  ) {
    return getPropertiesFromRegionalAPI(request, this.axiosInstance)
  }

  getRegionalStaticPage(
    request: Parameters<typeof getRegionalStaticPageAPI>[0],
  ) {
    return getRegionalStaticPageAPI(request, this.axiosInstance)
  }

  getPropertiesFromStaticRegional(
    request: Parameters<typeof getPropertiesFromStaticRegionalAPI>[0],
  ) {
    return getPropertiesFromStaticRegionalAPI(request, this.axiosInstance)
  }
}

export class ReviewsPageClient {
  private axiosInstance: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance
  }

  getReviewsContent() {
    return getReviewsContentAPI(this.axiosInstance)
  }

  getReviewsList(request: Parameters<typeof getReviewsListAPI>[0]) {
    return getReviewsListAPI(request, this.axiosInstance)
  }
}

export class AgentClient {
  private axiosInstance: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance
  }

  generateShareLink(request: Parameters<typeof generateShareLinkApi>[0]) {
    return generateShareLinkApi(request, this.axiosInstance)
  }

  getBookings(request: Parameters<typeof getAgentBookingsApi>[0]) {
    return getAgentBookingsApi(request, this.axiosInstance)
  }

  getStripeAccountDetails() {
    return getStripeAccountDetailsApi(this.axiosInstance)
  }

  getStripeAccountOptions() {
    return getStripeAccountOptionsApi(this.axiosInstance)
  }

  createStripeAccountLink(
    request: Parameters<typeof createStripeAccountLinkApi>[0],
  ) {
    return createStripeAccountLinkApi(request, this.axiosInstance)
  }

  stripeOnboard(request: Parameters<typeof stripeOnboardApi>[0]) {
    return stripeOnboardApi(request, this.axiosInstance)
  }

  getCountryList() {
    return getAgentCountryListApi(this.axiosInstance)
  }

  getCommissions(request: Parameters<typeof getAgentCommissionsApi>[0]) {
    return getAgentCommissionsApi(request, this.axiosInstance)
  }

  getAgencyUsers(request: Parameters<typeof getAgencyUsersApi>[0]) {
    return getAgencyUsersApi(request, this.axiosInstance)
  }

  createAgencyUser(request: Parameters<typeof createAgencyUserApi>[0]) {
    return createAgencyUserApi(request, this.axiosInstance)
  }

  deleteAgencyUser(userId: number) {
    return deleteAgencyUserApi(userId, this.axiosInstance)
  }

  resendAgencyInvite(userId: number) {
    return resendAgencyInviteApi(userId, this.axiosInstance)
  }

  updateAgencyUserRole(userId: number, params: UpdateAgencyUserRoleApiRequest) {
    return updateAgencyUserRoleApi(userId, params, this.axiosInstance)
  }

  getSuperAgent(request: Parameters<typeof getSuperAgent>[0]) {
    return getSuperAgent(request, this.axiosInstance)
  }

  getPayoutConfig() {
    return getPayoutConfigApi(this.axiosInstance)
  }

  updatePayoutConfig(request: Parameters<typeof updatePayoutConfigApi>[0]) {
    return updatePayoutConfigApi(request, this.axiosInstance)
  }
}
